module.exports = __webpack_public_path__ + "img/Bioscience & Biotechnology.60729628.jpg";